jQuery(document).ready(function ($) {
  /*--------------- Top bar Slider JS Start ---------------*/
  var topBarSlider = new Swiper(".top-bar-slider", {
    direction: "vertical",
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    breakpoints: {
      768: {
        slidesPerView: 1,
        spaceBetween: 8,
      },
    },
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
  });
  /*--------------- Top bar Slider JS End ---------------*/
  /*--------------- Category Slider JS Start ---------------*/
  var categorySlider = new Swiper(".category-slider", {
    slidesPerView: 1.4,
    spaceBetween: 13,
    breakpoints: {
      601: {
        slidesPerView: 2.4,
        spaceBetween: 13,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 26,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 26,
      },
      1280: {
        slidesPerView: 5,
        spaceBetween: 26,
      },
    },
  });
  /*--------------- Category Slider JS End ---------------*/
  /*--------------- Workday Slider JS Start ---------------*/
  var workdaySlider = new Swiper(".workday-slider", {
    slidesPerView: 1.1,
    spaceBetween: 12,
  });
  /*--------------- Workday Slider JS End ---------------*/
  /*--------------- Collection Slider JS Start ---------------*/
  var collectionThumbnail = new Swiper(".collection-thumbnail", {
    slidesPerView: "auto",
    spaceBetween: 10,
    watchSlidesProgress: true,
  });

  var collectionSlider = new Swiper(".collection-slider", {
    slidesPerView: 1,
    loop: true,
    loopedSlides: 6,
    speed: 1000,
    thumbs: {
      swiper: collectionThumbnail,
    },
  });
  var collectionProductSlider = new Swiper(".collection-product-slider", {
    slidesPerView: 3,
    spaceBetween: 12,
    speed: 1000,
    navigation: {
      nextEl: ".co-pr-next",
      prevEl: ".co-pr-prev",
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 12,
      },
      1025: {
        slidesPerView: 3.23,
        spaceBetween: 0,
      },
    },
  });
  /*--------------- Collection Slider JS End ---------------*/
  /*--------------- Workday Slider JS Start ---------------*/
  var utilityInner = new Swiper(".utility-inner", {
    slidesPerView: 1,
    spaceBetween: 12,
    breakpoints: {
      601: {
        slidesPerView: 2,
        spaceBetween: 26,
      },
      1280: {
        slidesPerView: 3,
        spaceBetween: 26,
      },
    },
  });
  /*--------------- Workday Slider JS End ---------------*/
  /*--------------- Recommended Slider JS Start ---------------*/
  var recommendedThumbnailSlider = new Swiper(".recommended-thumbnail-slider", {
    slidesPerView: 2,
    spaceBetween: 10,
    watchSlidesProgress: true,
    breakpoints: {
      601: {
        slidesPerView: 4,
        spaceBetween: 10,
      },
      1025: {
        slidesPerView: "auto",
        spaceBetween: 10,
      },
    },
  });

  var recommendedSlider = new Swiper(".recommended-slider", {
    slidesPerView: 1,
    loopedSlides: 6,
    speed: 1000,
    navigation: {
      nextEl: ".recommended-slider-next",
      prevEl: ".recommended-slider-prev",
    },
    thumbs: {
      swiper: recommendedThumbnailSlider,
    },
  });
  /*--------------- Recommended Slider JS End ---------------*/
  /*--------------- Mega menu JS Start ---------------*/
  $("body")
    .on("mouseenter click", ".main-menu > ul > li.sub-menu", function () {
      const subMenuHeight = $(this).find(".main-sub-menu").outerHeight() || 0;
      $("body").css("--subMenuHeight", `${subMenuHeight}px`);
    })
    .on("mouseleave", ".main-menu > ul > li.sub-menu", function () {
      $("body").css("--subMenuHeight", "0px");
    });
  /*--------------- Mega menu JS End ---------------*/
  /*--------------- Header JS Start ---------------*/
  function updateHeaderHeight() {
    var HeaderHeight = $(".main-header-section").outerHeight() + $(".top-bar").outerHeight();
    $("body").css("--HeaderHeight", HeaderHeight + "px");
  }

  $(window).on("load resize", updateHeaderHeight);
  updateHeaderHeight();
  /*--------------- Header JS End ---------------*/
  /*--------------- Mobile menu JS Start ---------------*/
  $("body").on("click", ".mobile-menu-icon", function () {
    if ($(this).hasClass("open")) {
      $(this).removeClass("open");
      $(".mobile-menu").removeClass("open");
      $("body").removeClass("overflow-hidden");
      $(".mobile-menu-list .has-submenu").removeClass("active");
      $(".mobile-menu-list .has-submenu .submenu").slideUp(300);
    } else {
      $(this).addClass("open");
      $(".mobile-menu").addClass("open");
      $("body").addClass("overflow-hidden");
    }
  });
  $("body").on("click", ".mobile-menu .mobile-menu-wrapper", function () {
    $(".mobile-menu-icon").removeClass("open");
    $(".mobile-menu").removeClass("open");
    $("body").removeClass("overflow-hidden");
    $(".mobile-menu-list .has-submenu").removeClass("active");
    $(".mobile-menu-list .has-submenu .submenu").slideUp(300);
  });
  $("body").on("click", ".has-submenu > a", function (e) {
    e.preventDefault();
    var $parent = $(this).parent();
    var $submenu = $parent.children(".submenu");
    if ($parent.hasClass("active")) {
      $parent.removeClass("active");
      $parent.find(".has-submenu").removeClass("active");
      $parent.find(".submenu").slideUp(300);
    } else {
      $parent.addClass("active");
      $submenu.stop(true, true).slideDown(300);
    }
  });
  /*--------------- Mobile menu JS End ---------------*/
  /*--------------- Search box JS Start ---------------*/
  $("body").on("click", ".mobile-search-icon", function () {
    if ($(".menu-header-right .search-bar").hasClass("open")) {
      $(".menu-header-right .search-bar").removeClass("open");
    } else {
      $(".menu-header-right .search-bar").addClass("open");
    }
  });
  /*--------------- Search box JS End ---------------*/
  /*--------------- PDP slider JS Start ---------------*/
  function initPdpThumb() {
    const isWide = window.matchMedia('(min-width: 480px)').matches;
    return new Swiper(".pdp-thumb", {
      centeredSlides: true,
      centeredSlidesBounds: true,
      direction: isWide ? "vertical" : "horizontal",
      slidesPerView: isWide ? 6 : 3,
      spaceBetween: isWide ? 8 : 10,
      freeMode: false,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      watchOverflow: true,
    });
  }

  var pdpThumb = initPdpThumb();
  var pdpSlider = new Swiper(".pdp-slider", {
    direction: "horizontal",
    spaceBetween: 10,
    loop: true,
    pagination: { el: ".swiper-pagination", type: "fraction" },
    navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
    thumbs: { swiper: pdpThumb },
  });

  window.matchMedia('(min-width: 480px)').addEventListener('change', () => {
    pdpThumb.destroy(true, true);
    pdpThumb = initPdpThumb();
    pdpSlider.thumbs.swiper = pdpThumb;
    pdpSlider.thumbs.init();
    pdpSlider.thumbs.update(true);
  });
  
  Fancybox.bind("[data-fancybox]", {
    Carousel: {
      Thumbs: {
        type: "classic",
      },
    },
  });
  /*--------------- PDP slider JS End ---------------*/
  /*--------------- Accordion JS Start ---------------*/
  $("body").on("click", ".accordion-heading", function () {
    var parents = $(this).parents(".accordion-item");
    parents.find(".accordion-body").slideToggle(300);
    $(this).toggleClass("active");
    if (parents.find(".view-details-btn")) {
      $(".view-details-btn").toggleClass("active");
      if ($(".view-details-btn").hasClass("active")) {
        $(".view-details-btn").text("View less details");
      } else {
        $(".view-details-btn").text("View more details");
      }
    }
  });
  $("body").on("click", ".view-details-btn", function () {
    var $btn = $(this);
    var $parent = $btn.closest(".accordion-item");
    $parent.find(".accordion-heading").toggleClass("active");
    $parent.find(".accordion-body").slideToggle(300);
    $btn.toggleClass("active");

    if ($btn.hasClass("active")) {
      $btn.text("View less details");
    } else {
      $btn.text("View more details");
    }
  });
  /*--------------- Accordion JS End ---------------*/
  /*--------------- Shop hero slider JS Start ---------------*/
  var shopHeroSlider = new Swiper(".shop-hero-slider", {
    slidesPerView: 1,
    spaceBetween: 68,
    watchSlidesProgress: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      601: {
        slidesPerView: 2,
        spaceBetween: 26,
      },
      1025: {
        slidesPerView: 3,
        spaceBetween: 116,
      },
    },
  });
  /*--------------- Shop hero slider JS End ---------------*/
  /*--------------- Select JS Start ---------------*/
  $("body")
    .on("focus", ".heading-select select", function () {
      $(this).closest(".heading-select").addClass("active");
    })
    .on("blur", ".heading-select select", function () {
      $(this).closest(".heading-select").removeClass("active");
    });
  /*--------------- Select JS End ---------------*/
  /*--------------- Image hover JS Start ---------------*/
  $("body").on("mouseenter", "[data-hover-img]", function () {
    var hoverImg = $(this).attr("data-hover-img");
    var img = $(this).closest(".product-item").find(".default-img");
    img.prop("src", hoverImg);
  });

  $("body").on("mouseleave", "[data-hover-img]", function () {
    var hoverImg = $(this)
      .closest(".product-item")
      .find(".default-img")
      .attr("data-default-url");
    var img = $(this).closest(".product-item").find(".default-img");
    img.prop("src", hoverImg);
  });
  /*--------------- Image hover JS End ---------------*/
  /*--------------- Side filter JS Start ---------------*/
  $("body").on("click", ".mob-filter-btn", function () {
    $(".filter-box, .side-shop-wrapper").toggleClass("open");
    $("body").toggleClass(
      "overflow-hidden",
      $(".filter-box").hasClass("open")
    );
  });
  $("body").on("click", ".side-shop-wrapper, .filter-side-close", function () {
    $(".filter-box, .side-shop-wrapper").removeClass("open");
    $("body").removeClass("overflow-hidden");
  });
  /*--------------- Side filter JS End ---------------*/
  /*--------------- PDP right height JS Start ---------------*/
  function updatePDPHeight() {
    var PDPrightHeight = $(".main-pdp-content-inner").outerHeight();
    $("body").css("--PDPrightHeight", PDPrightHeight + "px");
  }

  $(window).on("load resize", updatePDPHeight);
  updatePDPHeight();
  /*--------------- PDP right height JS End ---------------*/
  /*--------------- Hero slider section JS Start ---------------*/
  // var shopBGHeroSlider = new Swiper(".shop-bg-hero-slider", {
  //   slidesPerView: 1,
  //   spaceBetween: 10,
  //   loop: true,
  //   speed: 1000,
  //   autoplay: {
  //     delay: 3000,
  //     disableOnInteraction: false,
  //     pauseOnMouseEnter: true,
  //   },
  // });
  /*--------------- Hero slider section JS End ---------------*/
});
